// ProjectEventDetails.tsx
import { Table, Badge } from 'reactstrap';
import { CalendarAttivitaApi } from '../../../Types/Calendar.type';

function getStatoLabel(stato: number) {
  switch (stato) {
    case 682: return { text: 'Da fare', color: 'danger' };
    case 670: return { text: 'In corso', color: 'warning' };
    case 671: return { text: 'Completato', color: 'success' };
    default:  return { text: `Stato ${stato}`, color: 'secondary' };
  }
}

type Props = {
  projectName: string;
  activities: CalendarAttivitaApi[];
};

export function ProjectEventDetails({ projectName, activities }: Props) {
  return (
    <div className="table-responsive">
      <h5 className="mb-3">
        Attività progetto <strong>{projectName}</strong>
      </h5>

      <Table size="sm">
        <thead>
          <tr>
            <th >Descrizione</th>
            <th>Stato</th>
            <th  className='d-none md-block'>Utenti</th>
          </tr>
        </thead>
        <tbody>
          {activities.length === 0 && (
            <tr>
              <td colSpan={5}>Nessuna attività per questo progetto</td>
            </tr>
          )}

          {activities.map(a => {
            const { text, color } = getStatoLabel(a.stato as any);
            const data =
              (a.data_svolgere || a.data_esecuzione || '').slice(0, 10) || '-';

            const utentiLabel = (a.utenti || [])
              .map(u => u.nominativo || `${u.nome} ${u.cognome}`)
              .join(', ');

            return (
              <tr key={a.ID}>
                <td  style={{border:'none'}}  width={350}>{a.descrizione || '-'}</td>
                <td style={{border:'none'}}>
                  <Badge color={color}>{text}</Badge>
                </td>
                <td style={{border:'none'}} className='d-none md-block'>{utentiLabel || '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
